import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from "recharts";
import { useTranslation } from "react-i18next";

const COLORS = {
  win: "#689f38",
  loss: "#eb1418",
  draw: "#90a4ae",
};

const CombinedResultChart = ({ gameInfos, groupBy }) => {
  const { t } = useTranslation();

  // Track counts by group (team type or time type)
  const groupedCounts = {};

  gameInfos.forEach((game) => {
    const key = game[groupBy]; // 'gameTeamType' or 'gameTimeType'
    if (!key) return;

    const color = (game.color || "").toLowerCase();
    const winnerColor = (game.winnerColor || "").toLowerCase();

    let result;
    if (winnerColor === "neutral") {
      result = "draw";
    } else if (color === winnerColor) {
      result = "win";
    } else {
      result = "loss";
    }

    if (!groupedCounts[key]) {
      groupedCounts[key] = { win: 0, loss: 0, draw: 0 };
    }
    groupedCounts[key][result]++;
  });

  const chartData = Object.entries(groupedCounts).map(([key, results]) => ({
    //name: t(`${groupBy}.${key}`),
    name: t(`${key}`),
    ...results,
  }));

  const chartTitle = groupBy === "gameTeamType"
    ? t("chart.winLossByTeamType")
    : t("chart.winLossByTimeType");

  return (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px",
        marginBottom: "24px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      <h3 style={{
        marginBottom: "12px",
        fontSize: "1.25rem",
        fontWeight: "bold",
        textAlign: "center",
      }}>
        {chartTitle}
      </h3>

      <div style={{ width: "100%", height: window.innerWidth < 600 ? "250px" : "320px" }}>
        <ResponsiveContainer>
          <BarChart data={chartData}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="win" fill={COLORS.win} name={t("chart.win")} />
            <Bar dataKey="loss" fill={COLORS.loss} name={t("chart.lose")} />
            <Bar dataKey="draw" fill={COLORS.draw} name={t("chart.draw")} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CombinedResultChart;
